import React, { useEffect, useState } from 'react';

import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { WidgetLuccaAbsenceUser } from 'jamespot-user-api';

const WidgetLuccaAbsence = commonComponentsRegistry.getLazyComponent('WidgetLuccaAbsence');

export const JRCWidgetLuccaAbsenceWrapper = ({ url = '' }: { url: string }) => {
    const [list, setList] = useState<WidgetLuccaAbsenceUser[]>([]);

    useEffect(() => {
        if (!url.length) return;
        fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then((res) => res.json())
            .then(setList);
    }, [url]);

    return <WidgetLuccaAbsence list={list} />;
};
